import { c as _c } from "react/compiler-runtime";
import { renderStructuredContent } from '../../renderContext';
import type { ContentSpacingToken, StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
const SPACING_VARS: Record<string, string> = {
  xxs: 'var(--spacing-content-xxs, 4px)',
  xs: 'var(--spacing-content-xs, 8px)',
  sm: 'var(--spacing-content-sm, 12px)',
  md: 'var(--spacing-content-md, 16px)',
  lg: 'var(--spacing-content-lg, 24px)',
  xl: 'var(--spacing-content-xl, 32px)',
  xxl: 'var(--spacing-content-xxl, 48px)'
};
export type ContainerProps = StructuredContentDocumentWithRenderer<{
  spacing?: {
    top?: ContentSpacingToken;
    bottom?: ContentSpacingToken;
  };
  children: StructuredContentDocument;
}>;
export const Container = t0 => {
  const $ = _c(8);
  const {
    props: t1
  } = t0;
  const {
    children,
    spacing
  } = t1;
  const marginTop = spacing?.top ? SPACING_VARS[spacing.top] : undefined;
  const marginBottom = spacing?.bottom ? SPACING_VARS[spacing.bottom] : undefined;
  let t2;
  if ($[0] !== marginBottom || $[1] !== marginTop) {
    t2 = {
      marginTop,
      marginBottom
    };
    $[0] = marginBottom;
    $[1] = marginTop;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children) {
    t3 = renderStructuredContent(children);
    $[3] = children;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <div style={t2}>{t3}</div>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};